import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import SiteLayoutWrapper from "@/components/SiteLayoutWrapper";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import BookContact from "@/pages/BookContact";
import FAQ from "@/pages/FAQ";
import Policies from "@/pages/Policies";

function App() {
  return (
    <HelmetProvider>
        <BrowserRouter>
          <SmoothScroll />
          <Routes>


            {/* Site-layout marketing pages */}
            <Route element={<SiteLayoutWrapper />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/book" element={<BookContact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/policies" element={<Policies />} />
            </Route>

            {/* Legacy Emergent routes redirect to active public pages */}
            <Route path="/booking/*" element={<Navigate to="/book" replace />} />
            <Route path="/login" element={<Navigate to="/book" replace />} />
            <Route path="/register" element={<Navigate to="/book" replace />} />
            <Route path="/portal/*" element={<Navigate to="/book" replace />} />
            <Route path="/admin/*" element={<Navigate to="/" replace />} />
            <Route path="/auth/callback" element={<Navigate to="/" replace />} />

            {/* Catch-all */}
            <Route path="*" element={<Home />} />
          </Routes>

          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#141417",
                border: "1px solid rgba(255,255,255,0.15)",
                color: "#fff",
                borderRadius: 0,
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
